/* eslint-disable react/display-name */
import React, { FC } from 'react'
import { Button } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider from 'react-bootstrap-table2-toolkit'
import { Link } from 'react-router-dom'
import { getDomainName } from '../../../utils/envVariables'
import { formatUTCDate } from '../../../utils/stringTools'

import './index.css'

interface Props {
  resources: any;
}

const Resource: FC<Props> = ({ resources }: Props) => {

  const domainName = getDomainName()

  const columns = [{
    dataField: 'date',
    text: 'Date',
    sort: true,
    formatter: (cellContent, row) => formatUTCDate(cellContent)
  }, {
    dataField: 'fileLocation',
    text: 'Name',
    sort: true,
    formatter: (cellContent, row) => (
      <Link
        to='route'
        onClick={(event) => { event.preventDefault(); window.open(`${domainName}/pdf/locationApplication/resources/${row.title}`) }}
      >
        {row.title}
      </Link>
    )
  }, {
    dataField: 'documentCategory',
    text: 'Category',
    sort: true,
    formatter: (cellContent, row) => cellContent
  }, {
    dataField: 'action',
    text: 'Actions',
    sort: false,
    formatter: (cellContent, row) => (
      <Button
        className='action-btn'
        variant='info'
        onClick={(event: any) => {
          event.preventDefault()
          window.open(`${domainName}/pdf/locationApplication/resources/${row.title}`)
        }}
      >
        View
      </Button>
    )
  }]

  return (
    <div>
      <ToolkitProvider
        keyField='locationApplicationResourceId'
        bootstrap4
        data={resources}
        columns={columns}
        search
      >
        {
          (props: any) => (
            <BootstrapTable
              id='provider-application-resource-table'
              bordered={false}
              condensed
              bootstrap4
              noDataIndication={() => <div>No Resources found.</div>}
              {...props.baseProps}
            />
          )
        }
      </ToolkitProvider>
    </div>
  )
}

export default Resource